// extracted by css-extract-rspack-plugin
export default {"ReviewThreadContainer":"ReviewThread-module__ReviewThreadContainer__IxmRvoT"};